/**
 * @fileoverview DELETE handler for the single
 * "/companies/:company_id/custom_domains/:domain_type/:domain_parent_id/:domain_id/app_linking_assignment"
 * endpoint.
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteCompaniesCompanyIdCustomDomainsAppLinkingAssignmentCacheKeys } from "./constants";
import type { DeleteCompaniesCompanyIdCustomDomainsAppLinkingAssignmentProps } from "./types";

export const deleteCompaniesCompanyIdCustomDomainsAppLinkingAssignment = reactQueryMutationAdapter(
  deleteCompaniesCompanyIdCustomDomainsAppLinkingAssignmentCacheKeys,
  ({
    companyId,
    domainType,
    domainParentId,
    domainId,
  }: DeleteCompaniesCompanyIdCustomDomainsAppLinkingAssignmentProps): Promise<void> => {
    return fetch(
      `/companies/${companyId}/custom_domains/${domainType}/${domainParentId}/${domainId}/app_linking_assignment`,
      "DELETE",
      {},
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
